import { render, staticRenderFns } from "./_Form.vue?vue&type=template&id=c637c67e&scoped=true&"
import script from "./_Form.vue?vue&type=script&lang=js&"
export * from "./_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c637c67e",
  null
  
)

export default component.exports